import MainLayout from '@/components/layout/MainLayout.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Select2Multiple from 'v-select2-multiple-component';
import axios from "axios";
import store from "@/store";
import "vue-loading-overlay/dist/vue-loading.css";
import { required, maxLength } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import CONFIG from "@/assets/js/config.js";
import pdfIcon from '@/assets/images/pdf.png';
import docIcon from '@/assets/images/icon-doc.png';
import pptIcon from '@/assets/images/icon-ppt.png';

export default {
  name: "createAssignment",

  components: {
    MainLayout,
    DatePicker,
    Select2Multiple
  },

  data() {
    return {
      createAssignment: {
        course_id: 0,
        class_ids: [],
        title: '',
        description: '',
        from_date: '',
        to_date: '',
        files: [],
      },
      courses: [],
      classes: [],
      submitted: false,
      disabled: false,
      submit_permission: false,
      date_invalid_error: false,
      CONFIG,
      pdfIcon,
      docIcon,
      pptIcon
    };
  },

  validations: {
    createAssignment: {
      course_id: {
        required
      },
      title: {
        required,
        maxLength: maxLength(100)
      },
      description: {
        maxLength: maxLength(5000)
      },
      from_date: {
        required
      },
      to_date: {
        required,
      }
    }
  },

  computed: {
    ...mapGetters(["teacherId", "schoolId", "userType"]),
    isClassRequired() {
      var course = this.courses.find(course => course.course_id == this.createAssignment.course_id);
      if (course && course.course_type != CONFIG.COURSE_TYPE.VIDEO && !this.createAssignment.class_ids.length) {
        return false;
      } else {
        return true;
      }
    },
    validCourse() {
      if (this.createAssignment.course_id && !this.courses.indexOf(this.createAssignment.course_id)) {
        return false;
      } else {
        return true;
      }
    }
  },

  methods: {
    date_check() {
      var from_date = this.createAssignment.from_date;
      var to_date = this.createAssignment.to_date;
      if (to_date != '' && to_date < from_date) {
        this.date_invalid_error = true;
      } else {
        this.date_invalid_error = false;
      }
    },

    onChange(event, fieldName) {
      if (fieldName === 'course') {
        this.createAssignment.class_ids = [];
        if (event.target.value != 0) {
          var course;
          if (this.createAssignment.course_id == event.target.value) {
            course = this.courses.find(course => course.course_id == event.target.value)
          } else {
            course = this.courses.find(course => course.course_id == this.createAssignment.course_id)
          }
          if (course && course.course_type != CONFIG.COURSE_TYPE.VIDEO) {
            this.getClasses(course.course_id);
          } else {
            this.classes = [];
          }
        } else {
          this.classes = [];
        }
      }
    },

    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },

    getCourses() {
      axios.get("my/course/teacherCoursesList", {
        params: {
          allCourseType: true
        }
      })
        .then(res => {
          this.courses = res.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('/');
          }
          console.log(error);
        });
    },

    getClasses($course_id) {
      axios.get(`my/course/${$course_id}/classesForAssignment`)
        .then(res => {
          var defaultOption = [
            {
              id: 0,
              text: 'တန်းခွဲ အားလုံး'
            }
          ];
          this.classes = defaultOption.concat(res.data.map($class => {
            return {
              id: $class.class_id,
              text: `${$class.course_name} (${CONFIG.CLASS_TYPE_LABEL[$class.class_type]})`,
            }
          }));
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('/');
          }
          console.log(error);
        });
    },

    submit() {
      if (this.date_invalid_error == false) {
        this.submitted = true;
        this.submit_permission = false;
        if (!this.createAssignment.course_id || this.$v.createAssignment.$invalid || !this.isClassRequired) {
          return;
        }

        this.create();
      } else {
        this.submit_permission = true;
      }
    },

    create() {
      this.disabled = true;

      axios.post(`my/assignment/create`, this.createRequest())
        .then(res => {
          let message = null;
          if (res.status == 200) {
            this.$router.push({
              name: "manageAssignment"
            });
            message = "လုပ်ဆောင်မှု အောင်မြင်ပါသည်။";
          } else {
            this.disabled = false;
            this.$router.push({
              name: "createAssignment"
            });
            message = "လုပ်ဆောင်မှု မအောင်မြင်ပါ။";
          }

          this.$notification.success(message, {
            timer: 3,
            position: "bottomCenter"
          });
        }).catch(error => {
          this.disabled = false;
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('/');
          }
          console.log(error);
          this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
            timer: 3,
            position: "bottomCenter"
          });
        });
    },

    createRequest() {
      let formData = new FormData();
      for (let key in this.createAssignment) {
        var data = this.createAssignment[key];
        if (Array.isArray(data)) {
          if (key == "class_ids" && data.find(id => id == 0)) {
            this.classes.forEach(item => {
              if (item.id) formData.append(`${key}[]`, item.id);
            });
          } else if (key == 'files') {
            data.forEach((item, index) => {
              formData.append(`${key}[${index}]`, item.file);
            })
          } else {
            data.forEach(item => {
              formData.append(`${key}[]`, item);
            });
          }
        } else {
          formData.append(key, data);
        }
      }
      return formData;
    },

    notificationCount() {
      var id = null;
      var type = this.userType;
      if (this.teacherId) {
        id = this.teacherId;
      }
      if (this.studentId) {
        id = this.studentId;
      }
      axios.get("my/notification/count", {
        params: {
          id: id,
          type: type
        }
      })
        .then(response => {
          store.commit("setNotificationCount", response.data);
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('/');
          }
          console.log(error, "error");
        });
    },

    chooseFiles(id) {
      document.getElementById(id).click();
    },

    onFileChange(e) {
      const selectedFiles = e.target.files;
      if (!selectedFiles || !selectedFiles.length) return;

      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];

        const parts = file.name.split('.');
        const fileExtension = parts.length > 1 ? parts.pop().toLowerCase() : '';

        if (!CONFIG.ASSIGNMENT.ALLOWED_FILE_TYPES.includes(file.type) || fileExtension === 'jfif') {
          this.$notification.error(CONFIG.ASSIGNMENT.ERROR.Type, {
            timer: 3,
            position: "bottomCenter",
          });
          continue;
        }

        if (file.size > CONFIG.ASSIGNMENT.MAX_FILE_SIZE) {
          this.$notification.error(CONFIG.ASSIGNMENT.ERROR.Max_Size, {
            timer: 3,
            position: "bottomCenter",
          });
          continue;
        }
        if (this.createAssignment.files.length >= CONFIG.ASSIGNMENT.MAX_FILE_COUNT) {
          this.$notification.error(CONFIG.ASSIGNMENT.ERROR.Max_Count, {
            timer: 3,
            position: "bottomCenter",
          });
          break;
        }

        const isDuplicate = this.createAssignment.files.some(f => f.name === file.name && f.file && f.file.size === file.size);
        if (isDuplicate) {
          this.$notification.error(`"${file.name}" ${CONFIG.ASSIGNMENT.ERROR.Duplicate ?? 'is already added.'}`, {
            timer: 3,
            position: "bottomCenter",
          });
          continue;
        }

        const fileObj = {
          file: file,
          name: file.name,
          type: file.type,
          data: null
        };

        this.createAssignment.files.push(fileObj);

        if (file.type.match(/image/i)) {
          const reader = new FileReader();
          reader.onload = () => {
            fileObj.data = reader.result;
          };
          reader.readAsDataURL(file);
        }
      }
      const inputEl = document.getElementById('answer-file');
      if (inputEl) inputEl.value = null;
    },

    removeFile(i) {
      this.createAssignment.files.splice(i, 1);
      const inputEl = document.getElementById('answer-file');
      if (inputEl) inputEl.value = null;
    },

    confirmRemoveFile(i) {
      const message = 'ဤ File ကို ဖျက်ရန် သေချာပါသလား?';
      if (window.confirm(message)) {
        this.removeFile(i);
      }
    },
  },

  mounted() {
    this.getCourses();
    this.notificationCount();
  },
}
